import { render, staticRenderFns } from "./ShiftVDPFact.vue?vue&type=template&id=b6ef1462&"
import script from "./ShiftVDPFact.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPFact.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftVDPFact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports